import SUGGESTED_REGIONS from '../../../config/outdoorRegions';

export default SUGGESTED_REGIONS;
